<template>
  <NuxtLayout>
    <div class="app_container w">
      <div
        v-loading="ctrl.loading1"
        class="block"
      >
        <el-carousel
          v-if="map.advList.length > 0"
          height="455px"
          arrow="never"
          class="carousel"
        >
          <el-carousel-item
            v-for="(i,index) in map.advList"
            :key="index"
          >
            <custom-link
              :to="handleNavigate(i)"
              :target-type="i.targetType"
            >
              <img
                class="article_img"
                :src="i.imageUrl"
                :alt="i.advName"
              >
            </custom-link>
          </el-carousel-item>
        </el-carousel>
        <div class="hot">
          <p class="recommend">
            热门推荐
          </p>
          <template v-if="map.hotList.length > 0">
            <div
              v-for="(i,index) in map.hotList"
              :key="index"
              class="item"
              @click="viewDetail(i.id)"
            >
              <p class="title">
                {{ i.title }}
              </p>
              <p class="c_999 tx-ov flex-item">
                {{ i.readCount }}人已浏览
              </p>
            </div>
          </template>
          <div
            v-else
            class="no_data"
          >
            暂无数据
          </div>
        </div>
      </div>
      <teacher-category-list
        :list="map.categorys"
        name="categoryName"
        :style="2"
        :default-id="map.categoryId"
        @change="changeCategory"
      />
      <div v-loading="ctrl.loading2">
        <article-list :list="map.articleList" />
      </div>
      <div
        v-if="page.totalPage > 1"
        class="pagination"
      >
        <el-pagination
          v-model:currentPage="page.pageCurrent"
          v-model:pageSize="page.pageSize"
          background
          layout="total, prev, pager, next, jumper"
          :total="page.totalCount"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
import { articleCategory, articleAdvList, articleHot, articlePage } from '../../api/article.js'
import { onMounted, nextTick } from 'vue'
import cookie from '@/utils/cookies'
import { teacherPage, teacherRankList } from '../../api/teacher'
import { parseTime } from '@/utils/index.js'

const cookieData = cookie.getShop()
useHead({
  title: computed(() => `资讯中心-${cookieData.shopName}`),
  meta: [{
    hid: 'keywords',
    name: 'keywords',
    content: '资讯中心'
  },
  {
    hid: 'description',
    name: 'description',
    content: '资讯中心'
  }]
})
const route = useRoute()
const map = reactive({
  advList: [],
  categorys: [],
  categoryId: route.query.categoryId || '',
  hotList: [],
  articleList: []
})
const page = reactive({
  totalCount: 0,
  pageCurrent: 1,
  pageSize: 20,
  totalPage: 1
})
const ctrl = reactive({
  loading1: false,
  loading2: false
})
const router = useRouter()
const changeCategory = (id) => {
  const query = route.query
  router.push({
    query: Object.assign({ ...query }, { categoryId: id },
      () => {})
  })
  map.categoryId = id
  getArticleList()
}

const viewDetail = (id) => {
  router.push({
    path: '/article/view',
    query: {
      id
    }
  })
}
const handleCurrentChange = (v) => {
  page.pageCurrent = v
  document.querySelector('#app').scrollTop = 0
  getArticleList()
}
const getArticleList = () => {
  ctrl.loading2 = true
  articlePage({
    pageCurrent: page.pageCurrent,
    pageSize: page.pageSize,
    categoryId: map.categoryId
  }).then(res => {
    if (res) {
      map.articleList = res.list || []
      page.pageCurrent = res.pageCurrent
      page.totalCount = res.totalCount
      page.totalPage = res.totalPage
    }
    ctrl.loading2 = false
  })
}
const getAdvList = () => {
  ctrl.loading1 = true
  articleAdvList().then(res => {
    if (res) {
      if (res.length === 0) {
        map.advList = [
          {
            imageUrl: 'https://static.roncoos.com/edu/pc/carousel.png',
            targetType: 99,
            advName: ''
          }
        ]
      } else {
        map.advList = res
      }
    }
    ctrl.loading1 = false
  })
}
const nowDay = new Date().getTime()
const beginTime = parseTime(nowDay - 30 * 24 * 60 * 60 * 1000)
const getHotList = () => {
  ctrl.loading1 = true
  articleHot({ size: 10, beginTime }).then(res => {
    map.hotList = res || []
    ctrl.loading1 = false
  })
}
const { data, pending, error } = await useAsyncData('ArticleListPage', () => {
  return new Promise(async (resolve) => {
    if (route.query) {
      map.categoryId = route.query.categoryId
    }
    Promise.allSettled([
      articleAdvList(),
      articleCategory(),
      articleHot({ size: 10, beginTime }),
      articlePage({
        pageCurrent: page.pageCurrent,
        pageSize: page.pageSize,
        categoryId: map.categoryId
      })
    ]).then(([adList, category, hotList, article]) => {
      const data = {}
      if (adList.status === 'fulfilled') {
        data.adList = adList.value
      } else {
        data.adList = {}
      }
      if (category.status === 'fulfilled') {
        data.category = category.value
      } else {
        data.category = []
      }
      if (hotList.status === 'fulfilled') {
        data.hotList = hotList.value
      } else {
        data.hotList = []
      }
      if (article.status === 'fulfilled') {
        data.article = article.value
      } else {
        data.article = []
      }
      resolve(data)
    })
  })
}, { initialCache: false })

if (!pending.value && data.value) {
  const d = data.value
  if (d.adList.length === 0) {
    map.advList = [
      {
        imageUrl: 'https://static.roncoos.com/edu/pc/carousel.png',
        targetType: 99,
        advName: ''
      }
    ]
  } else {
    map.advList = d.adList
  }
  map.categorys = d.category.concat([])
  map.categorys.unshift({
    categoryName: '全部',
    id: ''
  })
  map.hotList = d.hotList || []
  map.articleList = d.article.list || []
  page.pageCurrent = d.article.pageCurrent
  page.totalCount = d.article.totalCount
  page.totalPage = d.article.totalPage
}

</script>
<style lang="scss">
.carousel {
  width: 820px;
  .article_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .el-carousel__indicators {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    bottom: 20px;
    padding: 0px 12px;
    padding-right: 6px;
    padding-bottom: 4px;
  }
  .el-carousel__button {
    width: 9px;
    height: 6px;
    border-radius: 15px;
    margin-right: 7px;
  }
  .is-active {
    .el-carousel__button {
      width: 15px;
    }
  }
  .el-carousel__indicator--horizontal {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
.content_page {
  width: 1200px;
  margin: 20px auto;
}
.block {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.hot {
  width: 360px;
  background: #FFFFFF;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 12px 15px 0 15px;
  .recommend {
    font-size: 20px;
    margin-bottom: 15px;
  }
  .no_data {
    color: #999;
    text-align: center;
    line-height: 353px;
  }
  .item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 19px;
    cursor: pointer;
    .title {
      width: 230px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
    &:last-child {
      margin-bottom: 0px;
    }
    &:hover p{
      color: #2256F6;
    }
  }
}
.pagination {
  text-align: center;
}
</style>
